<template>
  <intersect @enter="animate = true">
    <div class="partner-filter fadeUp" :class="animate ? 'animate' : ''">
      <div class="partner-filter-items-mob" :class="{ 'partner-filter-active': mobDropdown }">
        <button class="partner-mob-button" @click="mobDropdown = !mobDropdown">
          <div class="partner-mob-button-search">
            <svg xmlns="http://www.w3.org/2000/svg" width="22.335" height="22.34" viewBox="0 0 22.335 22.34" class="ng-star-inserted"><path data-name="Icon ionic-ios-search" d="M26.573,25.216l-6.212-6.27a8.852,8.852,0,1,0-1.344,1.361l6.171,6.229a.956.956,0,0,0,1.349.035A.962.962,0,0,0,26.573,25.216ZM13.4,20.383a6.99,6.99,0,1,1,4.944-2.047A6.947,6.947,0,0,1,13.4,20.383Z" transform="translate(-4.5 -4.493)" fill="#fff"></path></svg>
          </div>

          <div class="partner-mob-button-text">
            {{ $fn.tr("დეტალური ძიება") }}
          </div>

          <div class="partner-mob-button-expand">
            <template v-if="mobDropdown">-</template>
            <template v-else>+</template>
          </div>
        </button>

        <slide-up-down
          :active="mobDropdown"
          :duration="600"
          class="partner-mob-button-body"
        >
          <template v-for="item, index in filterItems">
            <div v-if="showFilterItem(item)" class="partner-filter-item" :class="{ 'partner-filter-item-active': index === activeIndex }" @click="selectFilter(index)">
              <div class="partner-filter-item-in">
                {{ item.title }}

                <svg xmlns="http://www.w3.org/2000/svg" width="7.953" height="4.477" viewBox="0 0 7.953 4.477">
                  <path id="Path" d="M0,0,3.27,3.27,6.539,0" transform="translate(0.707 0.707)" fill="none" stroke="#73737f" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="1"></path>
                </svg>
              </div>
            </div>
          </template>

          <div class="partner-search partner-search-mobile">
            <input v-model="state.searchVal" @keydown.enter="filterChecks('search')" type="text" :placeholder="$fn.tr('იპოვე სიტყვით..')" />

            <button @click="filterChecks('search')">
              <svg xmlns="http://www.w3.org/2000/svg" width="22.335" height="22.34" viewBox="0 0 22.335 22.34" class="ng-star-inserted"><path data-name="Icon ionic-ios-search" d="M26.573,25.216l-6.212-6.27a8.852,8.852,0,1,0-1.344,1.361l6.171,6.229a.956.956,0,0,0,1.349.035A.962.962,0,0,0,26.573,25.216ZM13.4,20.383a6.99,6.99,0,1,1,4.944-2.047A6.947,6.947,0,0,1,13.4,20.383Z" transform="translate(-4.5 -4.493)" fill="#fff"></path></svg>
            </button>
          </div>
        </slide-up-down>

        <portal to="popup">
          <transition name="fade">
            <div v-if="windowWidth < 1440 && activeIndex != -1" class="partner-filter-modal" :class="{ 'partner-filter-animate': activeIndex != -1 }">
              <div class="partner-filter-background" @click="activeIndex = -1"></div>

              <div class="partner-dropdown" @click.stop>
                <h3>{{ filterItems[activeIndex].title }}</h3>

                <div class="partner-filter-item-search">
                  <input v-model="filterItems[activeIndex].search" type="text" :placeholder="$fn.tr('იპოვე სიტყვით..')" />
                </div>

                <div class="partner-checkbox-items">
                  <template v-for="citem in getSearchedItems(filterItems[activeIndex].items, filterItems[activeIndex].search)">
                    <div v-if="showCheckbox(filterItems[activeIndex].value, citem.pid, citem.value)" class="partner-checkbox-item" :class="{ 'partner-checkbox-item--disabled': citem.disabled }">
                      <label>
                        <input type="checkbox" v-model="citem.checked" :value="citem.value" @change="toggleCheckBox(filterItems[activeIndex].value, citem.value, citem.checked)" hidden />

                        <div class="partner-checkbox">
                          <div class="partner-checkbox-check">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8" height="8" viewBox="0 0 8 8">
                              <path d="M6.039.429A1.111,1.111,0,0,1,7.556.2,1.025,1.025,0,0,1,7.79,1.668L4.431,6.1a1,1,0,0,1-1.493.115L.317,3.677a1.023,1.023,0,0,1,0-1.483,1.113,1.113,0,0,1,1.535,0L3.5,3.785Z" transform="translate(0 1)" fill="#fff"></path>
                            </svg>
                          </div>

                          <div class="partner-checkbox-text">
                            {{ citem.title }}
                          </div>
                        </div>
                      </label>
                    </div>
                  </template>
                </div>

                <div class="partner-filter-item-buttons">
                  <button class="partner-filter-item-clear" @click="clearChecks(filterItems[activeIndex].value, true)">
                    {{ $fn.tr("გასუფთავება") }}
                  </button>

                  <button class="partner-filter-item-submit" @click="filterChecks(filterItems[activeIndex].value, true)">
                    {{ $fn.tr("ძებნა") }}
                  </button>
                </div>
              </div>
            </div>
          </transition>
        </portal>
      </div>

      <div class="partner-filter-items" :class="{ 'partner-filter-items--four-filter': state['developers_location'].length }" v-click-outside="removeActive">
        <template v-for="item, index in filterItems">
          <div v-if="showFilterItem(item)" class="partner-filter-item" :class="{ 'partner-filter-item-active': index === activeIndex }" @click="selectFilter(index)">
            <div class="partner-filter-item-in">
              {{ item.title }}

              <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="ng-tns-c54-0"><path d="M5.00025 6.50001C4.74425 6.50001 4.48825 6.40201 4.29325 6.20701L0.29325 2.20701C-0.09775 1.81601 -0.09775 1.18401 0.29325 0.793006C0.68425 0.402006 1.31625 0.402006 1.70725 0.793006L5.01225 4.09801L8.30525 0.918006C8.70425 0.535006 9.33525 0.546006 9.71925 0.943006C10.1032 1.34001 10.0922 1.97401 9.69525 2.35701L5.69525 6.21901C5.50025 6.40701 5.25025 6.50001 5.00025 6.50001" fill="#555F62"></path></svg>
            </div>

            <div class="partner-dropdown" @click.stop>
              <h3>{{ item.title }}</h3>

              <div class="partner-filter-item-search">
                <input v-model="item.search" type="text" :placeholder="$fn.tr('იპოვე სიტყვით..')" />
              </div>

              <div class="partner-checkbox-items">
                <template v-for="citem in getSearchedItems(item.items, item.search)">
                  <div v-if="showCheckbox(item.value, citem.pid, citem.value)" class="partner-checkbox-item" :class="{ 'partner-checkbox-item--disabled': citem.disabled }">
                    <label>
                      <input type="checkbox" v-model="citem.checked" :value="citem.value" @change="toggleCheckBox(item.value, citem.value, citem.checked)" hidden />

                      <div class="partner-checkbox">
                        <div class="partner-checkbox-check">
                          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="8" height="8" viewBox="0 0 8 8">
                            <path d="M6.039.429A1.111,1.111,0,0,1,7.556.2,1.025,1.025,0,0,1,7.79,1.668L4.431,6.1a1,1,0,0,1-1.493.115L.317,3.677a1.023,1.023,0,0,1,0-1.483,1.113,1.113,0,0,1,1.535,0L3.5,3.785Z" transform="translate(0 1)" fill="#fff"></path>
                          </svg>
                        </div>

                        <div class="partner-checkbox-text">
                          {{ citem.title }}
                        </div>
                      </div>
                    </label>
                  </div>
                </template>
              </div>

              <div class="partner-filter-item-buttons">
                <button class="partner-filter-item-clear" @click="clearChecks(item.value)">
                  {{ $fn.tr("გასუფთავება") }}
                </button>

                <button class="partner-filter-item-submit" @click="filterChecks(item.value)">
                  {{ $fn.tr("ძებნა") }}
                </button>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div class="partner-search partner-search-desktop">
        <input v-model="state.searchVal" type="text" @keydown.enter="filterChecks('search')" :placeholder="$fn.tr('იპოვე სიტყვით..')" />

        <button @click="filterChecks('search')">
          <svg xmlns="http://www.w3.org/2000/svg" width="22.335" height="22.34" viewBox="0 0 22.335 22.34" class="ng-star-inserted"><path data-name="Icon ionic-ios-search" d="M26.573,25.216l-6.212-6.27a8.852,8.852,0,1,0-1.344,1.361l6.171,6.229a.956.956,0,0,0,1.349.035A.962.962,0,0,0,26.573,25.216ZM13.4,20.383a6.99,6.99,0,1,1,4.944-2.047A6.947,6.947,0,0,1,13.4,20.383Z" transform="translate(-4.5 -4.493)" fill="#fff"></path></svg>
        </button>
      </div>
    </div>
  </intersect>
</template>

<script>
import Intersect from 'vue-intersect';
export default {
  components: { 
    Intersect
  },
  props: {
    itemData: Array,
    current: Number,
  },
  data() {
    return{
      animate: false,
      filterItems: [
        {
          title: this.$fn.tr("დეველოპერი"),
          value: "developers",
          search: "",
          items: [
            {
              title: this.$fn.tr("ყველა"),
              slug: this.$fn.tr("ყველა"),
              value: "all",
              disabled: false,
              checked: false,
            },
          ],
        },
        {
          title: this.$fn.tr("სტატუსი"),
          value: "developers_project_status",
          search: "",
          items: [
            {
              title: this.$fn.tr("ყველა"),
              slug: this.$fn.tr("ყველა"),
              value: "all",
              disabled: false,
              checked: false,
            },
          ],
        },
        {
          title: this.$fn.tr("ქალაქი"),
          value: "developers_location",
          search: "",
          items: [
            {
              title: this.$fn.tr("ყველა"),
              slug: this.$fn.tr("ყველა"),
              value: "all",
              disabled: false,
              checked: false,
            },
          ],
        },
        {
          title: this.$fn.tr("უბანი"),
          value: "developers_location_region",
          search: "",
          items: [
            {
              title: this.$fn.tr("ყველა"),
              slug: this.$fn.tr("ყველა"),
              value: "all",
              disabled: false,
              checked: false,
            },
          ],
        },
      ],
      activeIndex: -1,
      state: {
        developers: [],
        developers_project_status: [],
        developers_location: [],
        developers_location_region: [],
        searchVal: "",
      },
      mobDropdown: false,
    }
  },
  methods: {
    selectFilter(index) {
      if (this.activeIndex === index) {
        this.activeIndex = -1;
      } else {
        this.activeIndex = index;
      }
    },
    removeActive() {
      if (this.windowWidth >= 1440) {
        this.activeIndex = -1;
      }
    },
    getSearchedItems(items, searchVal) {
      return items.filter(x => x.title.toLowerCase().includes(searchVal.toLowerCase()))
    },
    toggleCheckBox(taxName, val, checked) {
      if (this.state[taxName]) {
        const idIndex = this.state[taxName].findIndex(id => id === val);
        const filterItemsIndex = this.filterItems.findIndex(item => item.value === taxName);
        
        if (idIndex > -1) {
          this.state[taxName].splice(idIndex, 1);
        } else {
          this.state[taxName].push(val);
        }

        if (val === "all") {
          this.filterItems[filterItemsIndex].items.forEach(x => {
            if (x.value !== val) {
              x.disabled = checked;
            }
          });
        }
      }

      if (taxName === "developers_location") {
        const filterRegionIndex = this.filterItems.findIndex(item => item.value === "developers_location_region");

        if (filterRegionIndex > -1) {
          this.filterItems[filterRegionIndex].search = "";
          this.filterItems[filterRegionIndex].items.forEach(item => {
            item.disabled = false;
            item.checked = false;
          });
        }

        this.state["developers_location_region"] = [];
      }
    },
    clearChecks(taxName, closeModal) {
      if (this.state[taxName]) {
        const filterItemsIndex = this.filterItems.findIndex(item => item.value === taxName);

        if (filterItemsIndex > -1) {
          this.filterItems[filterItemsIndex].search = "";
          this.filterItems[filterItemsIndex].items.forEach(item => {
            item.disabled = false;
            item.checked = false;
          });
        }
        this.state[taxName] = [];
        this.$emit('removeFilter', taxName);

        if (closeModal) {
          this.activeIndex = -1;
        }
      }
    },
    filterChecks(taxName, closeModal) {
      this.$emit('addFilter', taxName);

      if (closeModal) {
        this.activeIndex = -1;
      }
    },
    showFilterItem(filterItem) {
      const filterRegionIndex = this.filterItems.findIndex(item => item.value === "developers_location_region");

      if ((filterItem.value === "developers_location_region" && !filterItem.items.some(item => this.state["developers_location"].includes(item.pid) || this.state["developers_location"].includes("all"))) || (filterRegionIndex > -1 && !(this.filterItems[filterRegionIndex].items.length - 1))) {
        return false
      }

      return true
    },
    showCheckbox(taxName, pid, value) {
      if (taxName === "developers_location_region" && !this.state["developers_location"].includes("all") && !this.state["developers_location"].includes(pid) && value !== "all") {
        return false
      }

      return true
    },
    stopScrollPropagations() {
      const scrollContainers = document.querySelectorAll(
        ".partner-checkbox-items"
      );

      scrollContainers.forEach(function (el) {
        el.addEventListener("scroll", function (e) {
          e.stopPropagation();
        });
        el.addEventListener("mousewheel", function (e) {
          e.stopPropagation();
        });
      });
    },
    setTaxonomyItems() {
      const taxonomies = [_.get(this.$store.state.indx, 'terms.developers'), _.get(this.$store.state.indx, 'terms.developers_project_status'), _.get(this.$store.state.indx, 'terms.developers_location')];

      const filterRegionIndex = this.filterItems.findIndex(item => item.value === "developers_location_region");
      
      taxonomies.forEach(tax => {
        if (tax.length) {
          const filterItemsIndex = this.filterItems.findIndex(item => item.value === tax[0].taxonomy);
          
          if (filterItemsIndex > -1) {
            tax.forEach(item => {
              if (item.taxonomy === "developers_location" && item.pid && filterRegionIndex > -1) {
                this.filterItems[filterRegionIndex].items.push({
                  title: item.title,
                  slug: item.slug,
                  value: item.id,
                  pid: item.pid,
                  disabled: false,
                  checked: false,
                });
              } else {
                this.filterItems[filterItemsIndex].items.push({
                  title: item.title,
                  slug: item.slug,
                  value: item.id,
                  pid: item.pid,
                  disabled: false,
                  checked: false,
                });
              }
            });
          }
        }
      });
    },
  },
  computed: {
    developers() {
      return _.get(this.$store.state.indx, 'terms.developers')
    },
    windowWidth() {
      return window.innerWidth
    }
  },
  watch: {
    state: {
      handler(ns) {
        this.$store.commit('setState', {key: 'developerFilter', val: ns.developers});
        this.$store.commit('setState', {key: 'statusFilter', val: ns.developers_project_status});
        this.$store.commit('setState', {key: 'cityFilter', val: ns.developers_location});
        this.$store.commit('setState', {key: 'regionFilter', val: ns.developers_location_region});
        this.$store.commit('setState', {key: 'searchFilter', val: ns.searchVal});
      },
      deep: true,
    },
  },
  mounted() {
    this.setTaxonomyItems();

    setTimeout(() => {
      this.stopScrollPropagations();
    }, 1000);
  },
};
</script>